<script lang="ts">
    export let text: string = 'Click me';
    export let disabled: boolean = false;
    export let showIcon: boolean = false;
</script>

<button class="btn-main" class:showIcon on:click {disabled}>
    {text}
    {#if showIcon}
        <icon></icon>
    {/if}
</button>

<style>
    .btn-main {
        background-color: var(--analytics-red);
        color: white;
        padding: 0 12px;
        border-radius: 5px;
        border: none;
        cursor: pointer;
        font-size: 16px;
        min-width: 140px;
        height: 32px;
        position: relative;
    }
    .showIcon {
        padding-right: 40px;
    }
    .btn-main icon {
        background-image: url('Icons/svg/navigate_next_FILL0_wght400_GRAD0_opsz24.svg');
        background-repeat: no-repeat;
        background-position: 0px center;
        background-size: 24px;
        position: absolute;
        width: 20px;
        height: 20px;
        padding: 0 10px;
        margin: 0 10px;
        opacity: 0.6;
    }
    .btn-main[disabled] {
        background-color: var(--automapa-grey-dark);
        cursor: not-allowed;
    }
</style>
